import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { API_URL } from "../../../config";
import user from "../../images/user.png";

const UpdatePassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token"); // ✅ get from URL

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [loader, setLoader] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!token) {
      return setError("Invalid or expired link");
    }

    if (!newPassword || !confirmPassword) {
      return setError("Both fields are required");
    }

    if (newPassword !== confirmPassword) {
      return setError("Passwords do not match");
    }

    try {
      setLoader(true);

      const response = await fetch(
        API_URL + "/update/type7/user/password",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token, // ✅ send token in header
          },
          body: JSON.stringify({
            newPassword,
          }),
        }
      );

      const data = await response.json();
      setLoader(false);

      if (data.status) {
        alert("Password updated successfully");
        navigate("/login");
      } else {
        setError(data.message || "Something went wrong");
      }
    } catch (err) {
      setLoader(false);
      setError("Server error");
    }
  };

  return (
    <div className="login-bg">
      <div className="wrp-login">
        <form onSubmit={handleSubmit}>
          <div className="login-content">
            <div className="login-database">
              <p >Reset Password</p>
            </div>

            <div className="user-img">
              <img src={user} alt="user-img" />
            </div>

            {/* New Password */}
            <div className="wrp-label passwordInput mrt-input">
              <label>New Password</label>
              <input
                type={showNewPassword ? "text" : "password"}
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <i
                className={`fa ${
                  showNewPassword ? "fa-eye-slash" : "fa-eye"
                } pass-eye`}
                onClick={() => setShowNewPassword(!showNewPassword)}
              ></i>
            </div>

            {/* Confirm Password */}
            <div className="wrp-label passwordInput mrt-input">
              <label>Confirm Password</label>
              <input
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <i
                className={`fa ${
                  showConfirmPassword ? "fa-eye-slash" : "fa-eye"
                } pass-eye`}
                onClick={() =>
                  setShowConfirmPassword(!showConfirmPassword)
                }
              ></i>
            </div>

            {error && <p className="invalid-p">{error}</p>}

            <button className="login-btn" type="submit">
              Update Password
              {loader && <div id="loader"></div>}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdatePassword;